// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"patio"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 21V4C4 4 7 2 12 2C17 2 20 4 20 4V21H4Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 10.5H12M8 14H12M8 17.5H12M8 8.5V21M12 21V8.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 21V4C4 4 7 2 12 2C17 2 20 4 20 4V21M4 21H3M4 21H20M20 21H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PatioIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'patio',
    ref,
    icon: element,
  },
));

PatioIcon.displayName = 'PatioIcon';

export default PatioIcon;
